<template>
  <div class="support-section">
    <div class="support-header">
      <h3>☕ {{ $t('support.title') }}</h3>
      <p>{{ $t('support.description') }}</p>
    </div>
    
    <div class="support-options">
      <!-- Buy Me a Coffee -->
      <div class="support-option" @click="handleSupportClick('buymeacoffee')">
        <div class="option-icon">
          <span>☕</span>
        </div>
        <div class="option-content">
          <h4>Buy Me a Coffee</h4>
          <p>{{ $t('support.buymeacoffee') }}</p>
        </div>
        <div class="option-arrow">→</div>
      </div>
      
      <!-- Ko-fi -->
      <div class="support-option" @click="handleSupportClick('kofi')">
        <div class="option-icon">
          <span>💖</span>
        </div>
        <div class="option-content">
          <h4>Ko-fi</h4>
          <p>{{ $t('support.kofi') }}</p>
        </div>
        <div class="option-arrow">→</div>
      </div>
      
      <!-- PayPal -->
      <div class="support-option" @click="handleSupportClick('paypal')">
        <div class="option-icon">
          <span>💰</span>
        </div>
        <div class="option-content">
          <h4>PayPal</h4>
          <p>{{ $t('support.paypal') }}</p>
        </div>
        <div class="option-arrow">→</div>
      </div>
      
      <!-- Patreon -->
      <div class="support-option" @click="handleSupportClick('patreon')">
        <div class="option-icon">
          <span>🎗️</span>
        </div>
        <div class="option-content">
          <h4>Patreon</h4>
          <p>{{ $t('support.patreon') }}</p>
        </div>
        <div class="option-arrow">→</div>
      </div>
    </div>
    
    <!-- Modal para confirmar redirección -->
    <div v-if="showRedirectModal" class="modal-overlay" @click="showRedirectModal = false">
      <div class="modal-content" @click.stop>
        <h3>{{ $t('support.redirectTitle') }}</h3>
        <p>{{ $t('support.redirectMessage') }} {{ selectedPlatformName }}</p>
        <div class="modal-actions">
          <button class="modal-cancel" @click="showRedirectModal = false">
            {{ $t('support.cancel') }}
          </button>
          <button class="modal-confirm" @click="confirmRedirect">
            {{ $t('support.continue') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupportSection',
  data() {
    return {
      showRedirectModal: false,
      selectedPlatform: null,
      supportPlatforms: {
        buymeacoffee: {
          name: 'Buy Me a Coffee',
          url: 'https://buymeacoffee.com/tu-usuario' // Reemplaza con tu URL real
        },
        kofi: {
          name: 'Ko-fi',
          url: 'https://ko-fi.com/tu-usuario' // Reemplaza con tu URL real
        },
        paypal: {
          name: 'PayPal',
          url: 'https://paypal.me/tu-usuario' // Reemplaza con tu URL real
        },
        patreon: {
          name: 'Patreon',
          url: 'https://patreon.com/tu-usuario' // Reemplaza con tu URL real
        }
      }
    }
  },
  computed: {
    selectedPlatformName() {
      return this.selectedPlatform ? this.supportPlatforms[this.selectedPlatform].name : ''
    }
  },
  methods: {
    handleSupportClick(platform) {
      this.selectedPlatform = platform
      this.showRedirectModal = true
    },
    confirmRedirect() {
      if (this.selectedPlatform && this.supportPlatforms[this.selectedPlatform]) {
        window.open(this.supportPlatforms[this.selectedPlatform].url, '_blank')
        /* this.trackSupportClick(this.selectedPlatform) */
      }
      this.showRedirectModal = false
    },
    /* trackSupportClick(platform) {
      // Aquí puedes agregar tracking de analytics
      console.log(`Usuario hizo clic en soporte: ${platform}`)
      
      // Ejemplo con Google Analytics (si lo tienes configurado)
      if (typeof gtag !== 'undefined') {
        gtag('event', 'support_click', {
          'event_category': 'engagement',
          'event_label': platform
        })
      }
    } */
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.support-section {
  margin: 30px 0;
  padding: 20px;
  background: $dark-bg-secondary;
  border-radius: 12px;
  box-shadow: $dark-card-shadow;
  border: 1px solid $dark-border-color;
}

.support-header {
  text-align: center;
  margin-bottom: 25px;
  
  h3 {
    color: $dark-accent-primary;
    margin-bottom: 10px;
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
  
  p {
    color: $dark-text-secondary;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.5;
  }
}

.support-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
}

.support-option {
  display: flex;
  align-items: center;
  padding: 15px;
  background: $dark-bg-tertiary;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid transparent;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    border-color: $dark-accent-primary;
    
    .option-arrow {
      transform: translateX(3px);
    }
  }
}

.option-icon {
  margin-right: 15px;
  font-size: 1.8rem;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(187, 134, 252, 0.1);
  border-radius: 50%;
}

.option-content {
  flex: 1;
  
  h4 {
    margin: 0 0 5px 0;
    color: $dark-text-primary;
    font-size: 1.1rem;
  }
  
  p {
    margin: 0;
    color: $dark-text-secondary;
    font-size: 0.9rem;
    line-height: 1.4;
  }
}

.option-arrow {
  color: $dark-accent-primary;
  font-weight: bold;
  transition: transform 0.3s ease;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: $dark-bg-secondary;
  border-radius: 12px;
  padding: 25px;
  max-width: 450px;
  width: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border: 1px solid $dark-border-color;
  
  h3 {
    color: $dark-accent-primary;
    margin-bottom: 15px;
    text-align: center;
  }
  
  p {
    color: $dark-text-secondary;
    margin-bottom: 25px;
    text-align: center;
    line-height: 1.5;
  }
}

.modal-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
  
  button {
    padding: 10px 20px;
    border-radius: 50px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
  }
}

.modal-cancel {
  background: $dark-bg-tertiary;
  color: $dark-text-primary;
  
  &:hover {
    background: $dark-border-color;
  }
}

.modal-confirm {
  background: $dark-accent-primary;
  color: white;
  
  &:hover {
    background: $dark-accent-secondary;
    transform: translateY(-2px);
  }
}

@media (max-width: 768px) {
  .support-options {
    grid-template-columns: 1fr;
  }
  
  .modal-actions {
    flex-direction: column;
  }
}
</style>